import { useState } from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { Services } from '@estercare/ester-shared'
import { theme } from '../../../../theme/theme'
import { ScreeningViewTemplate } from '../ScreeningTemplate'
import { OnClickButton } from '../../../buttons/onclick/OnClickButton'
import { GiftScreeningModal } from '../../GiftScreeningModal'
import { SuccessModal } from '../../../modals/SuccessModal'
import { BodySmall } from '../../../styles/Typography'
import { useGetActiveServicesQuery } from '../../../../api/ester-b2b-api/private/services/serviceQueries'
import { useUserStore } from '../../../../state/store'
import { useShallow } from 'zustand/react/shallow'

export const MaleScreeningView = () => {
  const { t } = useTranslation()
  const { data: activeServices } = useGetActiveServicesQuery({})
  const hasGiftScreeningService = activeServices?.includes(Services.GIFT_SCREENING)
  const { user, setUser } = useUserStore(useShallow((state) => ({ user: state.user, setUser: state.setUser })))
  const hasInvitedUser = user?.hasInvitedUser ?? false
  const [showInviteModal, setShowInviteModal] = useState(false)
  const [successEmail, setSuccessEmail] = useState<string | null>(null)

  const handleInviteSuccess = (email: string) => {
    setShowInviteModal(false)
    setSuccessEmail(email)
    if (user) setUser({ ...user, hasInvitedUser: true })
  }

  return (
    <>
      <ScreeningViewTemplate
        pageTitle={
          hasGiftScreeningService ? t('employee.screening.giftHeading') : t('employee.screening.maleScreeningTitle')
        }
        screeningTitle={
          hasGiftScreeningService ? t('employee.screening.giftHeading') : t('employee.screening.standardTitle')
        }
        screeningDescription={
          hasGiftScreeningService
            ? t('employee.screening.giftDescription')
            : `${t('employee.screening.maleUserTitle')}\n${t('employee.screening.maleUserDescription')}`
        }
        screeningTitleChildren={
          hasGiftScreeningService ? (
            <GiftSection>
              <OnClickButton
                text={t('employee.screening.giftButton')}
                onClick={() => setShowInviteModal(true)}
                buttonColor={theme.color.plum}
                disabled={hasInvitedUser}
                buttonStyle={{
                  width: '220px',
                  padding: `${theme.spacing.medium}px ${theme.spacing.mediumLarge}px`,
                  marginTop: `${theme.spacing.large}px`,
                }}
              />
              {hasInvitedUser && <AlreadyInvitedText>{t('employee.screening.giftAlreadyInvited')}</AlreadyInvitedText>}
            </GiftSection>
          ) : undefined
        }
        hideButton
      />

      {showInviteModal && (
        <GiftScreeningModal onClose={() => setShowInviteModal(false)} onSuccess={handleInviteSuccess} />
      )}

      {successEmail && (
        <SuccessModal
          title={t('employee.screening.giftSuccessTitle')}
          text={t('employee.screening.giftSuccessDescription', { email: successEmail })}
          onClose={() => setSuccessEmail(null)}
        />
      )}
    </>
  )
}

const GiftSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.tiny}px;
  margin-top: ${theme.spacing.mediumLarge}px;

  & > button {
    align-self: center;
  }
`

const AlreadyInvitedText = styled(BodySmall)`
  color: ${theme.color.grey4};
  text-align: center;
`
